import { Component, OnInit } from '@angular/core';
import { NavigationConstant } from '../../../../../shared/constant/navigation.constant';
import { Router } from '@angular/router';
import { LinkajaStorage } from '@shared/storage/linkaja.storage';

@Component({
  selector: 'app-payment-linkaja',
  templateUrl: './linkaja-payment-result.component.html',
  styleUrls: ['./linkaja-payment-result.component.css']
})
export class PaymentResultLinkajaComponent implements OnInit {
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  paymentResult = 'Success';
  isSuccess = true;

  failedReason;

  trxId: string;
  refNum: string;
  trxDate: string;
  transactionAmount: string;
  phoneNumber: string;

  constructor(
    private router: Router,
    private linkajaStorage: LinkajaStorage,
  ) { }

  ngOnInit(): void {
    if(this.linkajaStorage.data == null || this.linkajaStorage.paymentResult == null){
      this.router.navigate([NavigationConstant.LINKAJA_IDENTIFY]);
    }

    const formatter = new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
    });

    
    this.trxId = this.linkajaStorage.data.trx_id;
    this.refNum = this.linkajaStorage.data.ref_num;
    this.transactionAmount = formatter.format(this.linkajaStorage.data.amount);
    this.phoneNumber = this.linkajaStorage.data.dataLogin.phoneNumber;
    this.trxDate = this.getCurrentDate();
    
    if(!this.linkajaStorage.paymentResult.hasOwnProperty('status')){
      this.paymentResult = 'Failed';
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      this.isSuccess = false;
    }

  }

  goToInquiry() {
    const trxIdUrlEncoded = encodeURIComponent(this.linkajaStorage.data.trx_id);
    const refNumUrlEncoded = encodeURIComponent(this.linkajaStorage.data.ref_num);
    const urlParam = `?trxId=${trxIdUrlEncoded}&refNum=${refNumUrlEncoded}`;

    if(!this.linkajaStorage.paymentResult.hasOwnProperty('status')){
      window.location.href = this.linkajaStorage.data.failed_url.toString()+urlParam;
    }else{
      window.location.href = this.linkajaStorage.data.success_url.toString()+urlParam;
    }
  }

  getCurrentDate() {
    var currentdate = new Date(); 
    let monthsList = ['January', 'February', 'March', 'April',
     'May', 'June', 'July', 'August',
     'September', 'October', 'November', 'December'];
    return this.trxDate = currentdate.getDate() + " "
                + (monthsList[currentdate.getMonth()])  + " " 
                + currentdate.getFullYear() + " "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
  }

}
